// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1jf1u","info":"UpdateTermsInfo_info__23v_F"};